const redactedPhoneNumber = (phoneNumber: string) => {
  if (!phoneNumber || phoneNumber.length < 6) return ''
  const cutOffIndex = phoneNumber.length - 3
  return `${'*'.repeat(cutOffIndex)}${phoneNumber.substring(cutOffIndex)}`
}

export default redactedPhoneNumber
